import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';

import { receiveError } from '../../../../../store/actions/notificationAction';
import { fetchFinish, fetchPending } from '../../../../../store/actions/fetchingAction';

import ResponseError from '../../../../../models/ResponseError';
import userManagementReqHandler from '../../../../../api/userManagementRemote';

import roles from '../../../../../configs/roles';
import { Grid, Button } from '@material-ui/core';
import Check from '@material-ui/icons/Check';
import Clear from '@material-ui/icons/Clear';

import styles from './printUserDetails.module.css';

import environments from '../../../../../configs/environments';

interface PrintUserDetailsContainerProps {
  location: { search: any };
  receiveError: Function;
  fetchFinish: Function;
  fetchPending: Function;
};

interface PrintUserDetailsContainerState {
  userDetails: {
    email: string,
    password: string,
    firstName: string,
    lastName: string,
    role: string
  },
  atLeast8CharPassword: boolean;
  allTypesCharsPassword: boolean;
  showPrintPutton: boolean;
};
class PrintUserDetailsContainer extends Component<PrintUserDetailsContainerProps, PrintUserDetailsContainerState> {

  state = {
    userDetails: {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      role: '',
    },
    atLeast8CharPassword: false,
    allTypesCharsPassword: false,
    showPrintPutton: true,
  };

  componentDidMount() {

    const UrlQueryStrings = this.props.location.search;
    const query = queryString.parse(UrlQueryStrings);

    userManagementReqHandler.getStoredUserDetails(query.token as string).then(resp => {
      const data = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if (data) {
        this.setState({
          userDetails: {
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            password: data.password,
            role: roles.userRoleToString(data.role),
          }
        });
        this.setState(this.passwordValidation(data.password));
      }
    })
  }

  passwordValidation = (password: string) => {
    let atLeast8CharPassword = password.length >= 8;
    let atLeast1Number = false, atLeastOneSymbol = false, atLeastOneUpperCase = false;

    for (let i = 0; i < password.length; i++) {
      let c = password[i];
      if (c >= '0' && c <= '9')
        atLeast1Number = true;
      if (c >= 'A' && c <= 'Z')
        atLeastOneUpperCase = true;

      let specialChars: string = "!@#_";
      if (specialChars.indexOf(c) != -1)
        atLeastOneSymbol = true;
    }

    let allTypesCharsPassword = atLeast1Number && atLeastOneSymbol && atLeastOneUpperCase;

    return { atLeast8CharPassword, allTypesCharsPassword };
  }

  print = () => {
    this.setState({showPrintPutton: false}, () => {
      window.print();
      setImmediate(() => {
        this.setState({showPrintPutton: true});
      });
    });
  }

  render() {

    return (
      <Fragment>
        <div style={{ width: 500, margin: 'auto', fontSize: 20, marginTop: 30 }}>
          <Grid container style={{ paddingTop: 20 }}>
            <Grid item xs={5} style={{ color: '#AAAAAA' }}>
              First name:
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={5}>
              {this.state.userDetails.firstName}
            </Grid>
          </Grid>
          <Grid container style={{ paddingTop: 20 }}>
            <Grid item xs={5} style={{ color: '#AAAAAA' }}>
              Last name:
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={5}>
              {this.state.userDetails.lastName}
            </Grid>
          </Grid>
          <Grid container style={{ paddingTop: 20 }}>
            <Grid item xs={5} style={{ color: '#AAAAAA' }}>
              Email/Username:
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={5}>
              {this.state.userDetails.email}
            </Grid>
          </Grid>
          <Grid container style={{ paddingTop: 20 }}>
            <Grid item xs={5} style={{ color: '#AAAAAA' }}>
              Password:
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={5}>
              {this.state.userDetails.password}
            </Grid>
          </Grid>
          <Grid container style={{ paddingTop: 20 }}>
            <Grid item xs={5} style={{ color: '#AAAAAA' }}>
              Role:
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={5}>
              {this.state.userDetails.role}
            </Grid>
          </Grid>
        </div>
        <div className={ styles.passwordDescription }>
          The password assigned to you is a temporary password and you will be prompted to change it after
          your first login at <span className={ styles.url }>{ environments.appUrl }</span>. Please follow the password policy listed below to create a strong password.
          <div className={ styles.passwordPolicyHeader }>
            <span style={{ borderBottom: '1px solid #AAAAAA', paddingBottom: 8 }}>
              Password Policy:
            </span>
          </div>
          <div style={{ marginTop: 20 }}>
            {this.state.atLeast8CharPassword ? <Check style={{ color: 'green' }} /> : <Clear style={{ color: 'red' }} />} <span className={styles.greyText}>Must be at least 8 characters</span>
          </div>
          <div>
            {this.state.allTypesCharsPassword ? <Check style={{ color: 'green' }} /> : <Clear style={{ color: 'red' }} />} <span className={styles.greyText}>Must contain one upper case letter, one number and a special character</span>
          </div>
          <div style={{ marginTop: 20, textAlign: 'right', display: this.state.showPrintPutton? 'block': 'none' }}>
            <Button
              color="primary"
              variant="contained"
              onClick={this.print}
            >Print</Button>
          </div>
        </div>
      </Fragment>
    );
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    receiveError: (err: ResponseError) => dispatch(receiveError(err)),
    fetchFinish: () => dispatch(fetchFinish()),
    fetchPending: () => dispatch(fetchPending())
  };
};

export default connect(null, mapDispatchToProps)(PrintUserDetailsContainer);
